export default "__VITE_ASSET__dZDVMUBB__"